import React from 'react';
import styled from 'styled-components';

const EmailButtonStyles = styled.button`
  border-radius: 12px;
  background: #ffc9fb;
  padding: 14px 20px;
  width: 100%;
  margin: 16px 0 0;
  color: #171123;

  &:focus {
    outline: none;
  }

  &:disabled {
    background: #e0e2e8;
  }
`;

export const EmailButton = React.forwardRef<
  HTMLButtonElement,
  React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >
>(function EmailButton(props, ref) {
  return (
    <EmailButtonStyles {...props} ref={ref}>
      {props.children}
    </EmailButtonStyles>
  );
});
